import React from "react";
import PuzzleCardBase from "../../common/components/PuzzleCardBase";
import {
    getCrossCardContentPadding,
    getCrossNavigationPath,
    getCrossPlayData,
    getCrossProgress,
    getCrossWordCount
} from "../../common/utils/PuzzleCardHelpers";
import CrossService from "../CrossService";

const CrossCard = ({
    puzzle,
    userPayPlan,
    subscriptionStatus,
    onPlayClick,
    buttonText = "Play",
    isInProgress = false,
    forceUnlock = false,
    hideWordCountChip = false,
    belowDifficultySlot = null,
    browseStoriesChrome = false,
    hideClusteredBubbles = false,
    primaryActionReplacement = null,
    hideFreeTierBadge = false,
    actionButtonSx = null,
}) => {
    return (
        <PuzzleCardBase
            puzzle={puzzle}
            userPayPlan={userPayPlan}
            subscriptionStatus={subscriptionStatus}
            onPlayClick={onPlayClick}
            buttonText={buttonText}
            isInProgress={isInProgress}
            forceUnlock={forceUnlock}
            service={CrossService}
            getProgress={getCrossProgress}
            getPlayData={getCrossPlayData}
            getWordCount={getCrossWordCount}
            getNavigationPath={getCrossNavigationPath}
            getCardContentPadding={getCrossCardContentPadding}
            hideWordCountChip={hideWordCountChip}
            belowDifficultySlot={belowDifficultySlot}
            browseStoriesChrome={browseStoriesChrome}
            hideClusteredBubbles={hideClusteredBubbles}
            primaryActionReplacement={primaryActionReplacement}
            hideFreeTierBadge={hideFreeTierBadge}
            actionButtonSx={actionButtonSx}
        />
    );
};

export default CrossCard;
